<template>
    <div id="small-search-vue" class="position-relative">
        <div class="selector">
            <div class="d-flex align-items-end justify-content-between">
                <button type="button" data-toggle="tooltip" data-placement="top" :title="__('pages.booking.popover.type_1')" class="btn btn-selector" :class="booking_type == 1 ? 'active' : ''" v-on:click="selectBookingType(1)">{{__('pages.booking.type.type_1')}}</button>
                <button type="button" data-toggle="tooltip" data-placement="top" :title="__('pages.booking.popover.type_2')" class="btn btn-selector" :class="booking_type == 2 ? 'active' : ''" v-on:click="selectBookingType(2)">{{__('pages.booking.type.type_2')}}</button>
                <button type="button" data-toggle="tooltip" data-placement="top" :title="__('pages.booking.popover.type_3')" class="btn btn-selector" :class="booking_type == 3 ? 'active' : ''" v-on:click="selectBookingType(3)">{{__('pages.booking.type.type_3')}}</button>
                <button type="button" data-toggle="tooltip" data-placement="top" :title="__('pages.booking.popover.type_4')" class="btn btn-selector" :class="booking_type == 4 ? 'active' : ''" v-on:click="selectBookingType(4)">{{__('pages.booking.type.type_4')}}</button>
            </div>
        </div>
        <div class="d-block d-md-flex align-item-center justify-content-between">
            <div class="input">
                <i class="fa fa-times" aria-hidden="true"></i>
                <label for="search-where">{{__('pages.where')}}</label>
                <input type="text" id="search-where" v-model="where.string" :placeholder="__('pages.where_placeholder')" v-on:keyup="placeSearch">
                <ul class="autocompletes autocomplete-where" v-if="where_ac.length > 0">
                    <li v-for="(item, index) in where_ac" v-on:click="selectCountry(index)">
                        {{item.string}}
                    </li>
                </ul>
            </div>
            <div class="input">
                <label  v-if="booking_type == 1" for="search-when">{{__('pages.when')}}</label>
                <label  v-else for="search-when">{{__('pages.when_from')}}</label>
                <date-range-picker
                        ref="picker"
                        :locale-data="{ firstDay: 1, format: 'yyyy.mm.dd' }"
                        v-model="when"
                        :opens="'center'"
                        :singleDatePicker="true"
                        :timePicker="false"
                        :timePicker24Hour="false"
                        :showWeekNumbers="false"
                        :showDropdowns="false"
                        :ranges="false"
                        :autoApply="true"
                        :alwaysShowCalendars="true"
                        :timePickerIncrement="60"
                        @update="fromUpdateValues"
                        :dateFormat="dateFormat"       
                >
                </date-range-picker>
            </div>
            <div v-if="booking_type == 1" class="input">
                <label for="search-time-from">{{__('pages.time_from')}}</label>
                <div class="d-flex align-items-center">
                    <div class="select" style="width:50%;">
                        <select id="search-time-from" v-model="time_from">
                            <option value="00:00">00:00</option>
                            <option value="00:30">00:30</option>
                            <option value="01:00">01:00</option>
                            <option value="01:30">01:30</option>
                            <option value="02:00">02:00</option>
                            <option value="02:30">02:30</option>
                            <option value="03:00">03:00</option>
                            <option value="03:30">03:30</option>
                            <option value="04:00">04:00</option>
                            <option value="04:30">04:30</option>
                            <option value="05:00">05:00</option>
                            <option value="05:30">05:30</option>
                            <option value="06:00">06:00</option>
                            <option value="06:30">06:30</option>
                            <option value="07:00">07:00</option>
                            <option value="07:30">07:30</option>
                            <option value="08:00">08:00</option>
                            <option value="08:30">08:30</option>
                            <option value="09:00">09:00</option>
                            <option value="09:30">09:30</option>
                            <option value="10:00">10:00</option>
                            <option value="10:30">10:30</option>
                            <option value="11:00">11:00</option>
                            <option value="11:30">11:30</option>
                            <option value="12:00">12:00</option>
                            <option value="12:30">12:30</option>
                            <option value="13:00">13:00</option>
                            <option value="13:30">13:30</option>
                            <option value="14:00">14:00</option>
                            <option value="14:30">14:30</option>
                            <option value="15:00">15:00</option>
                            <option value="15:30">15:30</option>
                            <option value="16:00">16:00</option>
                            <option value="16:30">16:30</option>
                            <option value="17:00">17:00</option>
                            <option value="17:30">17:30</option>
                            <option value="18:00">18:00</option>
                            <option value="18:30">18:30</option>
                            <option value="19:00">19:00</option>
                            <option value="19:30">19:30</option>
                            <option value="20:00">20:00</option>
                            <option value="20:30">20:30</option>
                            <option value="21:00">21:00</option>
                            <option value="21:30">21:30</option>
                            <option value="22:00">22:00</option>
                            <option value="22:30">22:30</option>
                            <option value="23:00">23:00</option>
                            <option value="23:30">23:30</option>
                        </select>
                    </div>
                    <div style="padding:0 10px;">-</div>
                    <div class="select" style="width:50%;">
                        <select id="search-time-to" v-model="time_to">
                            <option value="00:00">00:00</option>
                            <option value="00:30">00:30</option>
                            <option value="01:00">01:00</option>
                            <option value="01:30">01:30</option>
                            <option value="02:00">02:00</option>
                            <option value="02:30">02:30</option>
                            <option value="03:00">03:00</option>
                            <option value="03:30">03:30</option>
                            <option value="04:00">04:00</option>
                            <option value="04:30">04:30</option>
                            <option value="05:00">05:00</option>
                            <option value="05:30">05:30</option>
                            <option value="06:00">06:00</option>
                            <option value="06:30">06:30</option>
                            <option value="07:00">07:00</option>
                            <option value="07:30">07:30</option>
                            <option value="08:00">08:00</option>
                            <option value="08:30">08:30</option>
                            <option value="09:00">09:00</option>
                            <option value="09:30">09:30</option>
                            <option value="10:00">10:00</option>
                            <option value="10:30">10:30</option>
                            <option value="11:00">11:00</option>
                            <option value="11:30">11:30</option>
                            <option value="12:00">12:00</option>
                            <option value="12:30">12:30</option>
                            <option value="13:00">13:00</option>
                            <option value="13:30">13:30</option>
                            <option value="14:00">14:00</option>
                            <option value="14:30">14:30</option>
                            <option value="15:00">15:00</option>
                            <option value="15:30">15:30</option>
                            <option value="16:00">16:00</option>
                            <option value="16:30">16:30</option>
                            <option value="17:00">17:00</option>
                            <option value="17:30">17:30</option>
                            <option value="18:00">18:00</option>
                            <option value="18:30">18:30</option>
                            <option value="19:00">19:00</option>
                            <option value="19:30">19:30</option>
                            <option value="20:00">20:00</option>
                            <option value="20:30">20:30</option>
                            <option value="21:00">21:00</option>
                            <option value="21:30">21:30</option>
                            <option value="22:00">22:00</option>
                            <option value="22:30">22:30</option>
                            <option value="23:00">23:00</option>
                            <option value="23:30">23:30</option>
                        </select>
                    </div>
                </div>
            </div>
            <div v-else class="input">
                <label for="search-when">{{__('pages.when_to')}}</label>
                <date-range-picker
                        ref="picker"
                        :locale-data="{ firstDay: 1, format: 'yyyy.mm.dd' }"
                        v-model="how_long_date"
                        :minDate="when_minDate"
                        :opens="'center'"
                        :singleDatePicker="true"
                        :timePicker="false"
                        :timePicker24Hour="false"
                        :showWeekNumbers="false"
                        :showDropdowns="false"
                        :ranges="false"
                        :autoApply="true"
                        :alwaysShowCalendars="true"
                        :timePickerIncrement="60"
                        @update="toUpdateValues"
                        :dateFormat="dateFormat"       
                >
                </date-range-picker>
            </div>
            <div class="button">
                <button type="button" class="btn btn-orange w-100 h-100" v-on:click="submit()" :title="__('pages.search')"><i class="far fa-search mr-2"></i><span>{{__('pages.search')}}</span></button>
            </div>
        </div>
    </div>
</template>
<script>
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
    data(){
        return {
            booking_type: 1,
            minDate: '',
            when_minDate: '',
            where: {
                zip: '',
                city: '',
                string: ''
            },
            where_ac: [],
            when: {startDate:this.getDate(), endDate: null},
            how_long_date: {startDate:this.getDate(), endDate: null},
            time_from: '10:00',
            time_to: '12:00',
        };
    },
    created(){
        if(this.params){
            this.where = {
                district: this.params.district ? this.params.district : '',
                city: this.params.city ? this.params.city : '',
                string: this.params.where ? this.params.where : ''
            };
            this.when = {startDate: this.params.when_start ? this.params.when_start : this.getDate(), endDate: this.params.when_end ? this.params.when_end : null};
            this.time_from = this.params.time_from ? this.params.time_from : '';
            this.time_to = this.params.time_to ? this.params.time_to : '';
            this.how_long_date = {startDate: this.params.when_end ? this.params.when_end : this.getDate(), endDate: null};
            this.booking_type = this.params.booking_type ? this.params.booking_type : 1;
        }
    },
    components: { DateRangePicker },
    props:['submit_url', 'params', 'filter_obj'],
    methods:{
        placeSearch: _.debounce(function(){
            if(this.where.city != ''){
                this.where.district = '';
                this.where.city = '';
            }
            let _self = this;
            axios.get( this.baseUrl('countries'), {params: {county: this.where.string}}).then(function(response){
                _self.where_ac = [];
                if(response.data.length == 1){
                    _self.where = response.data[0];
                    $('#small-search-vue .autocomplete-where').slideUp();
                }else{
                    _self.where_ac = response.data;
                    setTimeout(() => {
                        $('#small-search-vue .autocomplete-where').slideDown();
                    }, 100);
                }
            });
        }, 500),
        selectBookingType(type){
            this.booking_type = type;
        },

        selectCountry(index){
            if(this.where_ac[index] != undefined){
                this.where = this.where_ac[index];
                $('#small-search-vue .autocomplete-where').slideUp();
            }
        },
        fromUpdateValues(date){
            var dateEnd = new Date(date.startDate);
            dateEnd.setDate(dateEnd.getDate() - 1);
            
            this.when.startDate = this.getDate(date.startDate);
            this.how_long_date = date;
            this.when_minDate = this.getDate(dateEnd);
        },
        toUpdateValues(date){
            this.when.endDate = this.getDate(date.startDate);
        },
        dateFormat (classes, date) {
            if (!classes.disabled) {
                classes.disabled = date.getTime() < (new Date()).setDate((new Date()).getDate() - 1)
            }
            return classes
        },

        checkTimeFrom(){
            this.time_from = this.checkTime(this.time_from);
        },

        checkTimeTo(){
            this.time_to = this.checkTime(this.time_to);
        },

        checkTime(time){
            let hour = time.split(':')[0];
            if(!hour){
                return '';
            }else if(parseInt(hour) > 24){
                return '24:00';
            }else{
                return time;
            }
        },
        
        submit(){
            if(this.submit_url){
                window.location.href = this.submit_url + '?' + $.param({where: this.where.string, district: this.where.district, city: this.where.city, when_start: this.when.startDate, when_end: this.when.endDate, time_from: this.time_from, time_to: this.time_to, booking_type: this.booking_type});
            }

            if(this.filter_obj){
                window[this.filter_obj].setParams({district: this.where.district, city: this.where.city, when_start: this.when.startDate, when_end: this.when.endDate, time_from: this.time_from, time_to: this.time_to, booking_type: this.booking_type});
            }
        }    
    }
}
</script>